<router-outlet></router-outlet>
@if (!isMobileDevice) {
  <app-pc-tablet-error-dialog-component></app-pc-tablet-error-dialog-component>
}
